import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'delete-translation-exclusions' as const;

const argumentZod = z.object({
  ids: z
    .array(z.string())
    .min(1)
    .describe('The ids of the translation exclusion rules to delete'),
});

export const deleteTranslationExclusionsManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Delete translation exclusion rules',
  prettyStatus: {
    executing: 'Deleting translation exclusions…',
    executed: 'Deleted translation exclusions',
    failed: 'Deleting translation exclusions failed',
  },
  family: 'localization',
  llmTool: {
    name: toolName,
    description:
      'Permanently deletes one or more translation exclusion rules by id for the current site, re-enabling translation for the page or CMS collection fields they covered.',
    inputSchema: argumentZod,
  },
  type: 'server',
  requiredScopes: ['sites:write'],
  permission: [{resource: 'Site', action: 'update'}],
  confirmBeforeExecuting: true,
});

export type DeleteTranslationExclusionsArgumentType = z.infer<
  typeof argumentZod
>;
